import {Injectable} from '@angular/core';
import {GraphHelperService} from '../../diagram-render/helpers/graph-helper.service';
import {ShapeSpawnerService} from '../../diagram-render/shapes/shape-spawner.service';
import {EditorRegistryService} from '../../diagram-render/mx-graph/editor/editor-registry.service';
import {DiagramUpdateService} from '../../diagram-data/diagram-update.service';
import {ImageCreateCommand} from './image.create.command';
import {ImageDeleteCommand} from './image.delete.command';
import {SpinnerService} from '../../core/spinner/spinner.service';
import {ImageChangeCommand} from './image.change.command';
import {CircularDepCrutch} from '../../core/helpers/circular-dep.crutch';
import {StaticFileUploadService} from '@q9elements/ui-kit/common';

@Injectable()
export class ImageCommands extends CircularDepCrutch {
  private serviceObj: object;

  constructor(
    graphHelperSvc: GraphHelperService,
    shapeSpawnerSvc: ShapeSpawnerService,
    editorRegistrySvc: EditorRegistryService,
    diagramUpdateSvc: DiagramUpdateService,
    spinnerSvc: SpinnerService,
    q9StaticFileUploadSvc: StaticFileUploadService
  ) {
    super();
    this.serviceObj = {
      graphHelperSvc,
      shapeSpawnerSvc,
      editorRegistrySvc,
      diagramUpdateSvc,
      spinnerSvc,
      q9StaticFileUploadSvc
    };
  }

  public create(data) {
    return new ImageCreateCommand(data).injectServices(this.serviceObj);
  }

  public delete(data) {
    return new ImageDeleteCommand(data).injectServices(this.serviceObj);
  }

  public changeImage(data, modifications) {
    return new ImageChangeCommand(data, modifications).injectServices(this.serviceObj);
  }
}
